module.exports = __webpack_public_path__ + "static/media/coding_logo.e1fb680e.png";